 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		279: 0,
 		277: 0,
 		278: 0,
 		287: 0,
 		335: 0,
 		336: 0,
 		342: 0,
 		343: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","215":"AddClosedAlertIDUseCase","216":"CreateDeviceUseCase","217":"CreateDomestikaFollowUseCase","218":"CreateJWTUserUseCase","219":"CreateUserLiveSessionUseCase","220":"CurrentUserUseCase","221":"CurrentWithoutRelationshipsUserUseCase","222":"DeleteDeviceUseCase","223":"DeleteFollowUseCase","224":"ENV_CONFIG1","225":"ENV_CONFIG4","226":"ENV_CONFIG5","227":"ENV_CONFIG6","228":"ENV_CONFIG7","229":"FinishUserLiveSessionUseCase","230":"GetAccessTokenUserUseCase","231":"GetAdvanceGDPRStatusUserUseCase","232":"GetAllBlogUseCase","233":"GetAreasCourseUseCase","234":"GetCartCourseUseCase","235":"GetCategoriesCourseUseCase","236":"GetCourseUseCase","237":"GetFinalProjectVideoByCourseIDCourseUseCase","238":"GetGDPRStatusUserUseCase","239":"GetListLiveFeedbackQuestionUseCase","240":"GetListLiveSessionUseCase","241":"GetListLiveStreamUseCase","242":"GetLiveChannelUseCase","243":"GetLiveSessionUseCase","244":"GetOrganizationUseCase","245":"GetPlusPromotionUseCase","246":"GetPostContentBlogUseCase","247":"GetPromotionCodeAlertUseCase","248":"GetPromotionUseCase","249":"GetPubnubCredentialsUseCase","250":"GetSessionDataUserUseCase","251":"GetSimpleUserUseCase","252":"GetSoftwaresCourseUseCase","253":"GetUserAlertUseCase","254":"GetVideoProgressListCourseUseCase","255":"GetVideoSpeedUserUseCase","256":"GetVideoVolumeUserUseCase","257":"LogoutUserUseCase","258":"PathToRegexp","259":"RefreshAccessTokenUserUseCase","260":"RemoveAccessTokenUserUseCase","261":"SearchCourseUseCase","262":"SendHeaderTrackingUseCase","263":"SendLiveFeedbackAnswersUseCase","264":"SendPlayerTrackingUseCase","265":"SendTrackingUseCase","266":"SendVideoProgressCourseUseCase","267":"SetAdvanceGDPRStatusUserUseCase","268":"SetGDPRStatusUserUseCase","269":"SetVideoSpeedUserUseCase","270":"SetVideoVolumeUserUseCase","271":"UpdateLanguageUserUseCase","272":"UpdateLiveSessionUseCase","273":"UpdateVideoAudioAndSubtitlesCourseUseCase","274":"UpdateVideoProgressCourseUseCase","275":"ViewPageTrackingUseCase","341":"vendors~AddClosedAlertIDUseCase","342":"vendors~AlgoliaSearch","343":"vendors~AmplitudeJS","344":"vendors~SearchCourseUseCase","345":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"20222342c75419b6eda9","1":"e7dc2b52c07f7486b46e","2":"096454b427d6ebdc7538","3":"ae0b7855caabf1d13515","4":"b4b4fc6ab6759e5cccb0","5":"ecb5af25a727ce744de0","215":"aa6ec3d24755d08e071b","216":"be6193de616472695463","217":"18a348a3a2963b3ac270","218":"61dfb4c5cfad6212578c","219":"e0f896e5d73c10fcef12","220":"92860386d4f46c978a52","221":"a514634388467ea9c5f2","222":"99bd0f0ed6d4aed81e34","223":"336a1e85e2dc0626a3a2","224":"31a414c5c7326934e64e","225":"cde528eba31b4e6674c9","226":"9f1c25874db91232b76c","227":"74838d145dc3a0403e39","228":"773e9aee958b62d5f20c","229":"577429a442d9f20f65dc","230":"26322ef6a490ab13d1ec","231":"999e9df79d29d5ed8973","232":"58ec323acc79966e447f","233":"a5801a942768f7840ce8","234":"a006bde9a7738e00c9c6","235":"5330e6f826cb26f2f9e1","236":"7ec0bd80fa042b2f9f5c","237":"a6b284daeac82f6faccc","238":"25a56e3c7bc0f72d0c0f","239":"dea041f27f3a10146582","240":"336c8746a21b2f86bc12","241":"2248559f7109ad46ea99","242":"9a997fad20a0bf4eb1d2","243":"e0ec3720a35f70eae036","244":"180cad6122d60ae20260","245":"a8abf2031f79fbbff482","246":"842dfe14c6bb6a3fd572","247":"306e9549917402c4dd9c","248":"ce830725def91b2b11f1","249":"749cb3b94a35623f4f88","250":"eb6d3e690b08c99bb013","251":"7de3ff51503c827dbb02","252":"4030dc1bb2a1a0e5821d","253":"f3dc2107a95c297c1c14","254":"3cd9fe7b45d1144f1903","255":"cc24ed21626a696096cf","256":"4b44a59ca4e973fc86b3","257":"b7528e9e796854c62a4b","258":"c1d2f96f2a9f819856eb","259":"21c2204fef34c283fac2","260":"b853b8bf63880c88054d","261":"fef9d593bb00acbf4096","262":"f03227d05647870077d3","263":"44027d8389359fc5dae8","264":"3e81f10b8364e189951e","265":"680a1abd21f686ef2fcb","266":"7ac07452371a5092b7cc","267":"dcc0e3bf34791a3064b8","268":"07057deff61b963e569c","269":"2acb0db81f7835898b14","270":"ecd0cb472f4e78954693","271":"da8ed5489d588b9e3902","272":"19d6faf89e5f53a2f21e","273":"9c07b6d983df77a449bb","274":"e1808c77c269616ef76c","275":"94acac6449d98f5e0bc3","341":"558485e03d786c56b53a","342":"6c954bda7d5103c6c1ae","343":"513fff64fe0568a1790f","344":"52a658aab75691ffec8a","345":"3a503122e868066c84d3","419":"166709d4028d2f265914","637":"7ca3400d88f272d1771b","638":"e306c2061908a4aab08c","639":"80881459b41ad5365050"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2188);
